import { Link } from 'react-router-dom'
import { useLicenca } from './LicencaContext'

// Aviso amarelo: período de teste ou licença próxima do vencimento
export const LicencaAviso = () => {
  const { licenca } = useLicenca()

  if (!licenca?.b_exibir_aviso) return null

  const dias = licenca.n_dias_restantes ?? 0
  const quando = dias === 0 ? 'hoje' : `em ${dias} dia(s)`

  return (
    <div className='alert alert-warning mt-4 mx-4' role='alert'>
      <i className='bi bi-exclamation-triangle-fill me-2 text-warning'></i>
      {licenca.b_trial
        ? <>Você está no período de teste grátis, que termina {quando}.</>
        : <>Atenção! Sua licença vence {quando}.</>}
      &nbsp;&nbsp;
      <Link to='/renovacao' className='alert-link' style={{ textDecoration: 'underline' }}>
        Clique aqui para renovar sua licença
      </Link>
    </div>
  )
}
